import { UseFormReset } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { Form, FormField } from 'core/components';
import { InputType } from 'core/enums';
import { IMoveToForm } from 'quotes/types';

interface IProps {
  isOpen?: boolean;
  maxLineNumber?: number;
  onClose?: (reset?: UseFormReset<IMoveToForm>, closeSelection?: boolean) => void;
  onSubmit?: (reset?: UseFormReset<IMoveToForm>) => (data: IMoveToForm) => void;
}

const QuotePartMoveToFormView = ({ isOpen = false, maxLineNumber, onClose, onSubmit }: IProps) => {
  const { t } = useTranslation();

  return (
    <Form
      title={t('titleMoveTo')}
      isOpen={isOpen}
      onClose={onClose}
      submitBtnLabel={t('buttonLabelMove')}
      cancelBtnLabel={t('buttonLabelCancel')}
      onSubmit={onSubmit}
    >
      <FormField
        name="lineNumber"
        type={InputType.NUMBER_INPUT}
        inputProps={{
          label: t('labelLineNumber'),
          required: true,
          helperTexts: [t('messageMaxLineNumber', { maxLineNumber })],
          slotProps: {
            input: {
              min: 0,
              max: maxLineNumber,
              allowedDecimalSeparators: [],
              decimalScale: 0,
            },
          },
        }}
      />
    </Form>
  );
};

export default QuotePartMoveToFormView;
